const INVOICE_DOCUMENT_EXTENSIONS = new Set(['pdf', 'png', 'jpg', 'jpeg']);

export const INVOICE_DOCUMENT_UPLOAD_ACCEPT = '.pdf,.png,.jpg,.jpeg,.tsv,.csv,.txt';

export const INVOICE_DOCUMENT_UPLOAD_ACCEPT_WITH_JSON =
  '.pdf,.png,.jpg,.jpeg,.tsv,.csv,.txt,.json';

export function isInvoiceDocumentUpload(filename: string): boolean {
  const extension = filename.split('.').pop()?.toLowerCase();
  return extension != null && INVOICE_DOCUMENT_EXTENSIONS.has(extension);
}

export function getFileExtension(filename: string): string {
  return filename.split('.').pop()?.toLowerCase() ?? '';
}
